export enum DeviceSettingsType {
    BACK_LIGHT_COLOR = 'back_light_color',
    BACK_LIGHT_TEMPERATURE = 'back_light_temperature',
    BACK_LIGHT_BRIGHTNESS = 'back_light_brightness'
}
